<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6666 3.75008V4.58342C16.6666 4.69392 16.6227 4.7999 16.5445 4.87804C16.4664 4.95618 16.3604 5.00008 16.2499 5.00008H3.74992C3.63941 5.00008 3.53343 4.95618 3.45529 4.87804C3.37715 4.7999 3.33325 4.69392 3.33325 4.58342V3.75008C3.33325 3.63957 3.37715 3.53359 3.45529 3.45545C3.53343 3.37731 3.63941 3.33341 3.74992 3.33341H7.49992V2.50008C7.49992 2.39065 7.52147 2.28228 7.56335 2.18118C7.60523 2.08007 7.66661 1.98821 7.744 1.91083C7.82138 1.83344 7.91324 1.77206 8.01435 1.73018C8.11545 1.6883 8.22382 1.66675 8.33325 1.66675H11.6666C11.8876 1.66675 12.0996 1.75455 12.2558 1.91083C12.4121 2.06711 12.4999 2.27907 12.4999 2.50008V3.33341H16.2499C16.3604 3.33341 16.4664 3.37731 16.5445 3.45545C16.6227 3.53359 16.6666 3.63957 16.6666 3.75008ZM13.5666 15.0001H6.43325L5.83325 6.66675H4.16659L4.89159 16.7834C4.92116 17.2049 5.10973 17.5995 5.41914 17.8872C5.72856 18.175 6.13571 18.3345 6.55825 18.3334H13.4583C13.8808 18.3345 14.2879 18.175 14.5974 17.8872C14.9068 17.5995 15.0953 17.2049 15.1249 16.7834L15.8333 6.66675H14.1666L13.5666 15.0001Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DeleteOutlined',
} as DefineComponent
</script>
